/**
 * @typedef {import('./DataProvider').IProjectDataProvider} IProjectDataProvider
 */

export class ProjectDataProviderRepositoryClass {
    /**
     * @type {Map<string, IProjectDataProvider>}
     * @private
     */
    _dataProvidersMap = new Map();

    get() {
        return [...this._dataProvidersMap.values()];
    }

    /**
     * @param {string} dataProviderId
     * @return {IProjectDataProvider}
     */
    getById(dataProviderId) {
        return this._dataProvidersMap.get(dataProviderId);
    }

    /**
     * @param {IProjectDataProvider[]} dataProviders
     * @return {ProjectDataProviderRepositoryClass}
     */
    set(dataProviders) {
        this._dataProvidersMap = new Map(dataProviders.map((dp) => [dp.id, dp]));
        return this;
    }

    /**
     * @return {IProjectDataProvider?}
     */
    getDefault() {
        const dataProviders = this.get();
        const defaultDataProvider = dataProviders.find(({ isDefault }) => isDefault);
        if (defaultDataProvider != null) {
            return defaultDataProvider;
        }
        return dataProviders.length > 0 ? dataProviders[0] : null;
    }
}

export const ProjectDataProviderRepository = new ProjectDataProviderRepositoryClass();
